var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalAddUserToLocationVisible,
          expression: "isModalAddUserToLocationVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c("div", { staticClass: "modal-mask" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-slideout modal-lg" },
            [
              _c("div", { staticClass: "modal-content p-2" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "width-100" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase text-muted pt-1",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("img", {
                          staticClass: "back_icon mr-2",
                          attrs: {
                            src: require("@/assets/manager/back_button_icon.png")
                          }
                        }),
                        _vm._v("Back")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close float-right",
                        attrs: { type: "button" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col-9 pl-3" }, [
                      _c(
                        "div",
                        { staticClass: "h3 d-inline mr-2 text-uppercase" },
                        [
                          _vm._v(
                            _vm._s(_vm.accountName) +
                              " - " +
                              _vm._s(_vm.getBtnName)
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("form", [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v(
                            "\n                                        User Information\n                                        "
                          ),
                          _c("span", { staticClass: "required" }, [_vm._v("*")])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.first_name,
                              expression: "first_name"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                rules: {
                                  required: true,
                                  regex: _vm.nameRegex()
                                }
                              },
                              expression:
                                "{ rules: { required: true, regex: nameRegex() } }"
                            }
                          ],
                          ref: "first_name",
                          staticClass:
                            "col-12 col-sm-12 input-height-35 form-control",
                          attrs: {
                            type: "text",
                            id: "first_name",
                            name: "first_name",
                            placeholder: "First Name",
                            maxlength: "180",
                            autocomplete: "off"
                          },
                          domProps: { value: _vm.first_name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.first_name = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("first_name", "required")
                          ? _c(
                              "div",
                              { class: "validate-warning-msg " + _vm.vmessage },
                              [_vm._v("First Name is required")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("first_name", "regex")
                          ? _c(
                              "div",
                              { class: "validate-warning-msg " + _vm.vmessage },
                              [_vm._v("First Name should only contain - and _")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.last_name,
                              expression: "last_name"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                rules: {
                                  required: true,
                                  regex: _vm.nameRegex()
                                }
                              },
                              expression:
                                "{ rules: { required: true, regex: nameRegex() } }"
                            }
                          ],
                          ref: "last_name",
                          staticClass:
                            "col-12 col-sm-12 input-height-35 form-control",
                          attrs: {
                            type: "text",
                            id: "last_name",
                            name: "last_name",
                            placeholder: "Last Name",
                            maxlength: "180",
                            autocomplete: "off"
                          },
                          domProps: { value: _vm.last_name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.last_name = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("last_name", "required")
                          ? _c(
                              "div",
                              { class: "validate-warning-msg " + _vm.vmessage },
                              [_vm._v("Last Name is required")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("last_name", "regex")
                          ? _c(
                              "div",
                              { class: "validate-warning-msg " + _vm.vmessage },
                              [_vm._v("Last Name should only contain - and _")]
                            )
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 margin-t-10" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                }
                              ],
                              ref: "email",
                              staticClass:
                                "col-12 col-sm-12 input-height-35 form-control",
                              attrs: {
                                type: "text",
                                id: "email",
                                name: "email",
                                placeholder: "Email Address",
                                maxlength: "180",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.verrors.has("email")
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      "validate-warning-msg " + _vm.vmessage
                                  },
                                  [_vm._v("Email address is required")]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 margin-t-10" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.phone_number,
                                  expression: "phone_number"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    rules: { regex: _vm.adminPhoneRegex() }
                                  },
                                  expression:
                                    "{ rules: { regex: adminPhoneRegex() } }"
                                }
                              ],
                              ref: "phone_number",
                              staticClass:
                                "col-12 col-sm-12 input-height-35 form-control",
                              attrs: {
                                type: "text",
                                id: "phone_number",
                                name: "phone_number",
                                placeholder: "Phone Number",
                                maxlength: "14",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.phone_number },
                              on: {
                                keyup: function($event) {
                                  return _vm.adminPhoneValid($event)
                                },
                                blur: function($event) {
                                  return _vm.adminPhoneValid($event)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.phone_number = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.verrors.has("phone_number")
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      "validate-warning-msg " + _vm.vmessage
                                  },
                                  [_vm._v("Phone number is invalid")]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-4" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("label", { staticClass: "form-label" }, [
                              _vm._v(
                                "\n                                                User Type:\n                                            "
                              ),
                              _c("span", { staticClass: "required" }, [
                                _vm._v("*")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass:
                                  "col-12 col-sm-12 input-height-35 form-control",
                                attrs: {
                                  name: "user_role",
                                  id: "user_role",
                                  options: _vm.roles_options
                                },
                                on: { change: _vm.changeUserRole },
                                model: {
                                  value: _vm.user_role,
                                  callback: function($$v) {
                                    _vm.user_role = $$v
                                  },
                                  expression: "user_role"
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("user_role", "required")
                                ? _c(
                                    "div",
                                    {
                                      class:
                                        "validate-warning-msg " + _vm.vmessage
                                    },
                                    [_vm._v("User Type is required")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _vm.user_role == "ROLE_MENTEE" ||
                        _vm.user_role == "ROLE_APPRENTICE"
                          ? _c("div", { staticClass: "row mt-1" }, [
                              _c("div", { staticClass: "col-6 col-sm-6" }, [
                                _c("div", { staticClass: "input-group mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "input-group-prepend" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "input-group-text" },
                                        [_vm._v("$")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|numeric",
                                        expression: "'required|numeric'"
                                      },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.compensation,
                                        expression: "compensation"
                                      }
                                    ],
                                    ref: "compensation",
                                    staticClass:
                                      "col-12 col-sm-12 input-height-35 form-control",
                                    attrs: {
                                      type: "text",
                                      name: "compensation",
                                      id: "compensation",
                                      "data-vv-as": "Starting Compensation",
                                      maxlength: "5"
                                    },
                                    domProps: { value: _vm.compensation },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.compensation = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "input-group-append" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "input-group-text" },
                                        [_vm._v("/hr")]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.verrors.has("compensation"),
                                        expression:
                                          "verrors.has('compensation')"
                                      }
                                    ],
                                    class:
                                      "validate-warning-msg " + _vm.vmessage
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.verrors.first("compensation"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-6 col-sm-6" },
                                [
                                  _c("date-picker", {
                                    attrs: {
                                      "disabled-date": _vm.notBeforeToday,
                                      format: "MM/DD/YYYY",
                                      clearable: false,
                                      editable: false,
                                      "input-class":
                                        "col-12 col-sm-12 input-height-35 form-control",
                                      "popup-style": _vm.datePickerStyle
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "icon-calendar",
                                        fn: function() {
                                          return [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-calendar red-color",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ]),
                                    model: {
                                      value: _vm.review_compensation,
                                      callback: function($$v) {
                                        _vm.review_compensation = $$v
                                      },
                                      expression: "review_compensation"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.verrors.has(
                                            "review_compensation"
                                          ),
                                          expression:
                                            "verrors.has('review_compensation')"
                                        }
                                      ],
                                      class:
                                        "validate-warning-msg " + _vm.vmessage
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.verrors.first(
                                            "review_compensation"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user_role == "ROLE_MENTEE" ||
                        _vm.user_role == "ROLE_APPRENTICE"
                          ? _c("div", { staticClass: "row mt-1" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-12",
                                  attrs: { id: "mentor-group-wrapper" }
                                },
                                [
                                  _c("multiselect", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      options: _vm.groups,
                                      "track-by": "value",
                                      label: "text",
                                      placeholder: "Select Mentor(s)",
                                      multiple: true,
                                      "close-on-select": false,
                                      "show-labels": false,
                                      name: "mentor_assigned[]",
                                      id: "mentor_assigned"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function(ref) {
                                          var values = ref.values
                                          var search = ref.search
                                          var isOpen = ref.isOpen
                                          return [
                                            values.length && !isOpen
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "multiselect__single"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getMentorDisplayText(
                                                          values.length,
                                                          values
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.mentor_assigned,
                                      callback: function($$v) {
                                        _vm.mentor_assigned = $$v
                                      },
                                      expression: "mentor_assigned"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "mentor_assigned[]",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          class:
                                            "margin-bottom-5 validate-warning-msg " +
                                            _vm.vmessage
                                        },
                                        [_vm._v("Mentor(s) is required")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tasklists.length > 0 &&
                        (_vm.user_role == "ROLE_MENTEE" ||
                          _vm.user_role == "ROLE_APPRENTICE")
                          ? _c("div", { staticClass: "row mt-1" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c("label", { staticClass: "form-label" }, [
                                  _vm._v("TaskLists")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row row_data_border" },
                                  _vm._l(_vm.tasklists, function(
                                    pitem,
                                    aindex
                                  ) {
                                    return _c(
                                      "div",
                                      { key: aindex, staticClass: "col-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "chkboxwrapper" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "custom-control custom-checkbox"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.tasklist_assigned,
                                                      expression:
                                                        "tasklist_assigned"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "checkbox",
                                                    id:
                                                      "tasklist_assigned_" +
                                                      aindex,
                                                    name: "tasklist_assigned"
                                                  },
                                                  domProps: {
                                                    value: pitem.id,
                                                    checked: Array.isArray(
                                                      _vm.tasklist_assigned
                                                    )
                                                      ? _vm._i(
                                                          _vm.tasklist_assigned,
                                                          pitem.id
                                                        ) > -1
                                                      : _vm.tasklist_assigned
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a =
                                                          _vm.tasklist_assigned,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = pitem.id,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.tasklist_assigned = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.tasklist_assigned = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.tasklist_assigned = $$c
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-control-label",
                                                    attrs: {
                                                      for:
                                                        "tasklist_assigned_" +
                                                        aindex
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(pitem.name))]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.courses.length > 0 && _vm.user_role
                          ? _c("div", { staticClass: "row margin-t-10" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c("label", { staticClass: "form-label" }, [
                                  _vm._v("Courses")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row row_data_border" },
                                  _vm._l(_vm.courses, function(pitem, sindex) {
                                    return _c(
                                      "div",
                                      { key: sindex, staticClass: "col-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "chkboxwrapper" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "custom-control custom-checkbox"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.courseSelected,
                                                      expression:
                                                        "courseSelected"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "checkbox",
                                                    id:
                                                      "course_assigned_" +
                                                      sindex,
                                                    name: "course_assigned"
                                                  },
                                                  domProps: {
                                                    value: pitem.id,
                                                    checked: Array.isArray(
                                                      _vm.courseSelected
                                                    )
                                                      ? _vm._i(
                                                          _vm.courseSelected,
                                                          pitem.id
                                                        ) > -1
                                                      : _vm.courseSelected
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a =
                                                          _vm.courseSelected,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = pitem.id,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.courseSelected = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.courseSelected = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.courseSelected = $$c
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-control-label",
                                                    attrs: {
                                                      for:
                                                        "course_assigned_" +
                                                        sindex
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(pitem.name))]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessments.length > 0 && _vm.user_role
                          ? _c("div", { staticClass: "row row_data_border" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c("label", { staticClass: "form-label" }, [
                                  _vm._v("Assessments")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row row_data_border" },
                                  _vm._l(_vm.assessments, function(
                                    pitem,
                                    aindex
                                  ) {
                                    return _c(
                                      "div",
                                      { key: aindex, staticClass: "col-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "chkboxwrapper" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "custom-control custom-checkbox"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.assessmentSelected,
                                                      expression:
                                                        "assessmentSelected"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "checkbox",
                                                    id:
                                                      "assessment_assigned_" +
                                                      aindex,
                                                    name: "assessment_assigned"
                                                  },
                                                  domProps: {
                                                    value: pitem.id,
                                                    checked: Array.isArray(
                                                      _vm.assessmentSelected
                                                    )
                                                      ? _vm._i(
                                                          _vm.assessmentSelected,
                                                          pitem.id
                                                        ) > -1
                                                      : _vm.assessmentSelected
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a =
                                                          _vm.assessmentSelected,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = pitem.id,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.assessmentSelected = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.assessmentSelected = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.assessmentSelected = $$c
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-control-label",
                                                    attrs: {
                                                      for:
                                                        "assessment_assigned_" +
                                                        aindex
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(pitem.name))]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center end_btn" }, [
                      _c(
                        "button",
                        {
                          class: "btn btn-sm text-center " + _vm.getBtnClass,
                          attrs: { type: "button" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v(_vm._s(_vm.getBtnName))]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" })
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a737459", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a737459","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/add_new_user.vue
// module id = null
// module chunks = 